/**
 * @generated SignedSource<<282057e38a9c56faaf75d9d3a8ff2c83>>
 * @relayHash 103caeeadf9ce00d6ebb1f832a134ed5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9f683c3ece3fcb25f40069f6c2709156903f9ccf85f1e9978c6f10ea56df49d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraSoftwareListEmbedQuery } from './src_jiraSoftwareListEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraSoftwareListEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b9f683c3ece3fcb25f40069f6c2709156903f9ccf85f1e9978c6f10ea56df49d",
    "metadata": {},
    "name": "src_jiraSoftwareListEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
